import angular from "angular";
import $ from 'jquery';
import vis from '../../../lib/vis/vis.js';

angular
    .module('ui-common')
    .directive('trackingTimeline', TrackingTimelineDirective);

function TrackingTimelineDirective() {
    return {
        restrict: 'E',
        replace: false,
        scope: {
            view: '@',
            reportsService: '=',
            filterService: '=',
            stateName: '@',
            isOrs: '<',
        },
        template: require('./timeline-directive.html'),
        controller: ThisDirectiveController,
        controllerAs: 'vm'
    };
}

ThisDirectiveController.$inject = ['$rootScope', '$scope', '$filter', '$element'];

function ThisDirectiveController($rootScope, $scope, $filter, $element) {
    const vm = this;

    const view = $scope.view;

    const isCalibration = view === 'calibration-control-center';
    const isWatchlist = view === 'watchlist-tracking';
    const isShipmentTracking = view === 'shipment-tracking';
    const isLatestShipmentTracking = view === 'latest-shipment-tracking';
    const isLatestDeviceTracking = view === 'latest-device-tracking';
    const isDeviceTracking = view === 'device-tracking';
    const isSentinelTracking = view === 'sentinel-tracking';

    const showLine = isDeviceTracking || isSentinelTracking || isShipmentTracking;
    const useNumericGroupIds = !showLine;
    const hasAnchorDetection = isCalibration || isLatestDeviceTracking ||
        isSentinelTracking || isWatchlist || isLatestShipmentTracking ||
        isShipmentTracking;

    const stateNames = ($scope.stateName || '').split(',').map(function (s) { return s.trim(); });

    const numericGroupIds = {
        'ok-none': 0,
        'ok-gps': 1,
        'ok-network': 2,
        'info-none': 3,
        'info-gps': 4,
        'info-network': 5,
        'warning-none': 6,
        'warning-gps': 7,
        'warning-network': 8,
        'ok-none-selected': 9,
        'ok-gps-selected': 10,
        'ok-network-selected': 11,
        'info-none-selected': 12,
        'info-gps-selected': 13,
        'info-network-selected': 14,
        'warning-none-selected': 15,
        'warning-gps-selected': 16,
        'warning-network-selected': 17,
        'ok-anchor': 18,
        'info-anchor': 19,
        'warning-anchor': 20,
        'ok-anchor-selected': 21,
        'info-anchor-selected': 22,
        'warning-anchor-selected': 23
    };

    const timeConfig = getTimeConfig(view, $scope.isOrs);

    let onRangeTimeout = null;

    const filterSvc = $scope.filterService;
    const reportsSvc = $scope.reportsService;

    const filterByPropertyName = isCalibration ? filterSvc.reports.filterByPropertyName : filterSvc.filterByPropertyName;

    vm.container = null;
    vm.timeline = null;
    vm.dataSet = new vis.DataSet({});
    vm.selectedItem = null;
    vm.hasLastReport = false;
    vm.showLastReport = view === 'device-tracking' || view === 'sentinel-tracking' ||
        view === 'shipment-tracking' || view === 'watchlist-tracking';
    vm.options = {
        width: '100%',
        height: '160px',
        orientation: 'top',
        sort: false,
        sampling: false,
        min: moment().subtract(1, 'year'),
        max: moment().add(2, 'day'),
        start: moment().subtract(timeConfig.startDays, 'day'),
        end: moment().add(2, 'day'),
        zoomMax: timeConfig.zoomMaxMs,
        zoomMin: 1 * 1 * 1 * 60 * 15 * 1000,
        showCurrentTime: false,
        dataAxis: {
            left: {
                title: {
                    text: filterByPropertyName
                }
            }
        }
    };

    if (!showLine) {
        vm.options.style = 'points';
    }

    vm.groups = buildGroups();
    vm.onFilterChange = onFilterChange;
    vm.onReportsChange = onReportsChange;
    vm.moveToReport = moveToReport;
    vm.moveToCurrentDay = moveToCurrentDay;
    vm.moveToCurrentWeek = moveToCurrentWeek;
    vm.moveToCurrentMonth = moveToCurrentMonth;
    vm.moveToLastReport = moveToLastReport;

    activate();

    ////////////////////////////////////////////////////////////////////////////

    function getTimeConfig(v, isOrs) {
        switch (v) {
            case 'device-tracking':
                return { startDays: 45, zoomMaxMs: 1 * 45 * 24 * 60 * 60 * 1000 };
            case 'latest-device-tracking': {
                const maxDays = isOrs ? 368 : 45;
                return { startDays: maxDays, zoomMaxMs: 1 * maxDays * 24 * 60 * 60 * 1000 };
            }
            case 'latest-shipment-tracking':
                return { startDays: 30, zoomMaxMs: 50 * 24 * 60 * 60 * 1000 };
            default:
                return { startDays: 30, zoomMaxMs: 1 * 30 * 24 * 60 * 60 * 1000 };
        }
    }

    function buildPointGroup(id, content, size, imageUrl) {
        const groupId = useNumericGroupIds ? numericGroupIds[id] : id;
        const group = {
            id: groupId,
            content: content,
            options: {
                drawPoints: {
                    enabled: true,
                    size: size,
                    style: 'image',
                    imageUrl: imageUrl
                }
            },
            className: 'timeline-report'
        };
        if (showLine) {
            group.options.style = 'points';
        }
        return group;
    }

    function buildGroups() {
        const groups = [];

        if (showLine) {
            groups.push({
                id: 'line',
                options: {
                    drawPoints: {
                        enabled: false
                    }
                },
                className: 'timeline-graph-line'
            });
        }

        groups.push(buildPointGroup('ok-none', 'Ok - No Location', 32, '../img/ok-none.png'));
        groups.push(buildPointGroup('ok-network', 'Ok - Network', 24, '../img/ok-network.png'));
        groups.push(buildPointGroup('ok-gps', 'Ok - Gps', 24, '../img/ok-gps.png'));
        groups.push(buildPointGroup('ok-anchor', 'Ok - Anchor', 24, '../img/ok-anchor.png'));
        groups.push(buildPointGroup('info-none', 'Info - No Location', 32, '../img/info-none.png'));
        groups.push(buildPointGroup('info-network', 'Info - Network', 24, '../img/info-network.png'));
        groups.push(buildPointGroup('info-gps', 'Info - Gps', 24, '../img/info-gps.png'));
        groups.push(buildPointGroup('info-anchor', 'Info - Anchor', 24, '../img/info-anchor.png'));
        groups.push(buildPointGroup('warning-none', 'Warn - No Location', 32, '../img/warning-none.png'));
        groups.push(buildPointGroup('warning-network', 'Warn - Network', 24, '../img/warning-network.png'));
        groups.push(buildPointGroup('warning-gps', 'Warn - Gps', 24, '../img/warning-gps.png'));
        groups.push(buildPointGroup('warning-anchor', 'Warning - Anchor', 24, '../img/warning-anchor.png'));

        groups.push(buildPointGroup('ok-none-selected', 'Ok - No Location - Selected', 32, '../img/ok-none-selected.png'));
        groups.push(buildPointGroup('ok-network-selected', 'Ok - Network - Selected', 24, '../img/ok-network-selected.png'));
        groups.push(buildPointGroup('ok-gps-selected', 'Ok - Gps - Selected', 24, '../img/ok-gps-selected.png'));
        groups.push(buildPointGroup('ok-anchor-selected', 'Ok - Anchor - Selected', 24, '../img/ok-anchor-selected.png'));
        groups.push(buildPointGroup('info-none-selected', 'Info - No Location - Selected', 32, '../img/info-none-selected.png'));
        groups.push(buildPointGroup('info-network-selected', 'Info - Network - Selected', 24, '../img/info-network-selected.png'));
        groups.push(buildPointGroup('info-gps-selected', 'Info - Gps - Selected', 24, '../img/info-gps-selected.png'));
        groups.push(buildPointGroup('info-anchor-selected', 'Info - Anchor - Selected', 24, '../img/info-anchor-selected.png'));
        groups.push(buildPointGroup('warning-none-selected', 'Warn - No Location - Selected', 32, '../img/warning-none-selected.png'));
        groups.push(buildPointGroup('warning-network-selected', 'Warn - Network - Selected', 24, '../img/warning-network-selected.png'));
        groups.push(buildPointGroup('warning-gps-selected', 'Warn - Gps - Selected', 24, '../img/warning-gps-selected.png'));
        groups.push(buildPointGroup('warning-anchor-selected', 'Warning - Anchor - Selected', 24, '../img/warning-anchor-selected.png'));

        return groups;
    }

    function activate() {
        vm.container = $element[0].querySelector('.tracking-timeline-container');
        vm.options.start = reportsSvc.fromDate;
        vm.options.end = reportsSvc.toDate;
        if ($scope.isOrs) {
            vm.options.moment = function (date) {
                return vis.moment(date).utc();
            };
        }
        vm.timeline = new vis.Graph2d(vm.container, vm.dataSet, vm.groups, vm.options);
        onFilterChange();

        if (view === 'device-tracking') {
            vm.timeline.fit();
        }

        vm.timeline.on('select', onEvent);
        vm.timeline.on('click', onEvent);
        vm.timeline.on('rangechanged', onRangeChange);

        $scope.$watch(
            function () {
                return filterSvc;
            },
            function () {
                const currentName = $rootScope.$state.current.name;
                if (stateNames.length > 0 && stateNames[0] !== '' && stateNames.indexOf(currentName) === -1) {
                    return;
                }
                onFilterChange();
            }, true
        );
        $scope.$watch(
            function () {
                return reportsSvc.selected;
            },
            function (report) {
                onSelectedReportChange(report);
            }, true
        );

        if (vm.showLastReport) {
            $scope.$watch(
                function () {
                    return reportsSvc.lastReport;
                },
                function (report) {
                    vm.hasLastReport = report;
                }, true
            );
        }

        $scope.$watchCollection(
            function () {
                return reportsSvc.reports;
            },
            function (reports) {
                onReportsChange(reports);
            }
        );

        if (isWatchlist) {
            $scope.$watch(
                function () {
                    return reportsSvc.selected;
                },
                function (report) {
                    onSelectedReportChange(report);
                }, true
            );
            $scope.$watchCollection(
                function () {
                    return reportsSvc.reports;
                },
                function (reports) {
                    onReportsChange(reports);
                }
            );
        }
    }

    function groupIdName(report) {
        if (hasAnchorDetection && (report.beaconType === "Sentinel 100A" || report.beaconType === "Mobile SDK Anchor")) {
            return (report.severity + '-anchor').toLowerCase();
        }

        const locationMethod = $filter('locationMethod')(report.locationMethod, report.latitude, report.longitude);
        return (report.severity + '-' + locationMethod).toLowerCase();
    }

    function resolveGroupId(name) {
        return useNumericGroupIds ? numericGroupIds[name] : name;
    }

    function getReportId(report) {
        if (isShipmentTracking) {
            return report.reportGuid;
        }
        if (isLatestShipmentTracking) {
            return report.shipment.shipmentId;
        }
        return report.guid;
    }

    function getSightingsCount(report) {
        if (isCalibration) {
            return undefined;
        }
        if (view === 'device-tracking' || view === 'shipment-tracking') {
            return report.countOfSightings;
        }
        return report.totalSightingsCount;
    }

    function getFilterRange() {
        return isCalibration ? filterSvc.reports.range : filterSvc.range;
    }

    const alternatePropertyNames = {
        'temperatureF': 'temperatureValueF',
        'temperatureValueF': 'temperatureF',
        'temperatureC': 'temperatureValueC',
        'temperatureValueC': 'temperatureC',
    };

    function getReportValue(report, property) {
        let value = report[property];
        if (value === undefined) {
            const alt = alternatePropertyNames[property];
            if (alt) {
                value = report[alt];
            }
        }
        return value;
    }

    function addItems(reports) {
        const items = [];
        const range = getFilterRange();
        const filterFn = isCalibration ? filterSvc.reports.filter : filterSvc.filter;

        _.forEach(reports, function (report) {
            const x = moment(report.messageTimeStamp).local().toDate().valueOf();
            const y = getReportValue(report, range.property);
            if (y === undefined || (y === null && !$scope.isOrs)) {
                return;
            }

            if (showLine) {
                items.push({
                    id: 'line-' + getReportId(report),
                    x: x,
                    y: y,
                    group: 'line'
                });
            }

            if (filterFn(report)) {
                const reportId = getReportId(report);

                if (isLatestShipmentTracking) {
                    const exists = items.find(function (element) {
                        return element.id === reportId;
                    });
                    if (exists) {
                        return;
                    }
                }

                const item = {
                    id: reportId,
                    x: x,
                    y: y,
                    group: resolveGroupId(groupIdName(report))
                };

                const sightings = getSightingsCount(report);
                if (sightings !== undefined) {
                    item.sightings = sightings;
                }

                items.push(item);
            }
        });

        vm.dataSet.clear();
        vm.dataSet.add(items);
        if (vm.selectedItem) {
            vm.dataSet.add(vm.selectedItem);
        }
    }

    function adjustTimelineScale() {
        const values = [];
        _.forEach(vm.dataSet.get(), function (item) {
            values.push(item.y);
        });

        if (values.length === 0) {
            return;
        }

        const buffer = 10;
        const range = getFilterRange();

        const scale = {
            min: values.length > 0 ? Math.min.apply(null, values) - buffer : range.min,
            max: values.length > 0 ? Math.max.apply(null, values) + buffer : range.max
        };

        const axisTitle = isCalibration
            ? filterSvc.reports.filterByPropertyName + ' (' + filterSvc.reports.range.suffix + ')'
            : filterSvc.filterByPropertyName;

        const visibility = buildVisibility();

        vm.timeline.setOptions(
            {
                dataAxis: {
                    left: {
                        title: {
                            text: axisTitle
                        },
                        range: {
                            min: scale.min,
                            max: scale.max
                        },
                        format: function (value) {
                            return '' + Math.round(value);
                        }
                    }
                },
                groups: {
                    visibility: visibility
                }
            }
        );
    }

    function buildVisibility() {
        if (useNumericGroupIds) {
            return {
                0: filterSvc.showOk,
                1: filterSvc.showOk,
                2: filterSvc.showOk,
                3: filterSvc.showInfo,
                4: filterSvc.showInfo,
                5: filterSvc.showInfo,
                6: filterSvc.showWarning,
                7: filterSvc.showWarning,
                8: filterSvc.showWarning,
                9: filterSvc.showOk,
                10: filterSvc.showOk,
                11: filterSvc.showOk,
                12: filterSvc.showInfo,
                13: filterSvc.showInfo,
                14: filterSvc.showInfo,
                15: filterSvc.showWarning,
                16: filterSvc.showWarning,
                17: filterSvc.showWarning,
                18: filterSvc.showOk,
                19: filterSvc.showInfo,
                20: filterSvc.showWarning,
                21: filterSvc.showOk,
                22: filterSvc.showInfo,
                23: filterSvc.showWarning
            };
        }

        return {
            'line': true,
            'ok-none': filterSvc.showOk,
            'ok-gps': filterSvc.showOk,
            'ok-network': filterSvc.showOk,
            'ok-anchor': filterSvc.showOk,
            'info-none': filterSvc.showInfo,
            'info-gps': filterSvc.showInfo,
            'info-network': filterSvc.showInfo,
            'info-anchor': filterSvc.showInfo,
            'warning-none': filterSvc.showWarning,
            'warning-gps': filterSvc.showWarning,
            'warning-network': filterSvc.showWarning,
            'warning-anchor': filterSvc.showWarning,
            'ok-none-selected': filterSvc.showOk,
            'ok-gps-selected': filterSvc.showOk,
            'ok-network-selected': filterSvc.showOk,
            'ok-anchor-selected': filterSvc.showOk,
            'info-none-selected': filterSvc.showInfo,
            'info-gps-selected': filterSvc.showInfo,
            'info-network-selected': filterSvc.showInfo,
            'info-anchor-selected': filterSvc.showInfo,
            'warning-none-selected': filterSvc.showWarning,
            'warning-gps-selected': filterSvc.showWarning,
            'warning-network-selected': filterSvc.showWarning,
            'warning-anchor-selected': filterSvc.showWarning
        };
    }

    function onFilterChange() {
        filterSvc.save();
        addItems(reportsSvc.reports);
        adjustTimelineScale();
        if (reportsSvc.selected) {
            onSelectedReportChange(reportsSvc.selected);
        }
    }

    function onEvent(props) {
        const firstTarget = props.event.firstTarget;

        if (firstTarget.nodeName === 'image') {
            const selectedId = getSelectedId();
            reportsSvc.selected = selectedId !== null && ('' + selectedId) === ('' + firstTarget.id)
                ? null
                : reportsSvc.get(firstTarget.id);
        } else {
            reportsSvc.selected = null;
        }
        $scope.$apply();
    }

    function getSelectedId() {
        if (!reportsSvc.selected) {
            return null;
        }
        if (isShipmentTracking) {
            return reportsSvc.selected.reportGuid;
        }
        if (isLatestShipmentTracking) {
            return reportsSvc.selected.shipment.shipmentId;
        }
        return reportsSvc.selected.guid;
    }

    function onRangeChange() {
        if (view === 'device-tracking' || view === 'sentinel-tracking') {
            if (reportsSvc.isLoading) {
                window.setTimeout(onRangeChange, 500);
                return;
            }
        }

        if (isCalibration || isLatestDeviceTracking || isLatestShipmentTracking) {
            console.log("onRangeChange", reportsSvc.selected);
        }

        const timelineWindow = vm.timeline.getWindow();
        if (reportsSvc.fromDate.isSame(timelineWindow.start) && reportsSvc.toDate.isSame(timelineWindow.end)) {
            return;
        }

        if (isCalibration || isLatestDeviceTracking || isLatestShipmentTracking) {
            if (reportsSvc.selected != null) {
                return;
            }
        }

        if (onRangeTimeout) {
            window.clearTimeout(onRangeTimeout);
        }
        onRangeTimeout = window.setTimeout(
            function () {
                if (isWatchlist) {
                    reportsSvc.load(reportsSvc.watchlist, moment(timelineWindow.start), moment(timelineWindow.end), false);
                } else if (isShipmentTracking) {
                    reportsSvc.load(moment(timelineWindow.start), moment(timelineWindow.end), true);
                } else if (isLatestDeviceTracking) {
                    reportsSvc.load(moment(timelineWindow.start), moment(timelineWindow.end)).then(function () {
                        $scope.$apply();
                    });
                    return;
                } else {
                    reportsSvc.load(moment(timelineWindow.start), moment(timelineWindow.end));
                }

                $scope.$apply();
            }, 500
        );
    }

    function onReportsChange(reports) {
        const timelineWindow = vm.timeline.getWindow();
        if (!reportsSvc.fromDate.isSame(timelineWindow.start) || !reportsSvc.toDate.isSame(timelineWindow.end)) {
            vm.timeline.setWindow(moment(reportsSvc.fromDate), moment(reportsSvc.toDate));
        }

        addItems(reports || reportsSvc.reports);
        adjustTimelineScale();
    }

    function onSelectedReportChange(report) {
        if (vm.selectedItem) {
            vm.dataSet.remove('selected');
            vm.selectedItem = null;
        }

        if (!report) {
            return;
        }

        const range = getFilterRange();

        let selectedY;
        if (isCalibration) {
            selectedY = 0.5;
        } else {
            selectedY = (typeof getReportValue(report, range.property) === 'undefined' || getReportValue(report, range.property) === null) ? range.min : getReportValue(report, range.property);
        }

        const timeStamp = isCalibration ? report.timeOfReport : report.messageTimeStamp;

        vm.selectedItem = {
            id: 'selected',
            group: resolveGroupId(groupIdName(report) + '-selected'),
            x: moment(timeStamp).local().toDate().valueOf(),
            y: selectedY,
        };
        vm.dataSet.add(vm.selectedItem);

        report.centerOnTimeline = function () {
            moveToReport(report);
        };
    }

    function moveToCurrentDay() {
        vm.timeline.setWindow(moment().subtract(24, 'hour'), moment().endOf('day'));
        $('#btn-timeline-day').blur();
    }

    function moveToCurrentWeek() {
        vm.timeline.setWindow(moment().subtract(7, 'day').startOf('day'), moment().endOf('day'));
        $('#btn-timeline-week').blur();
    }

    function moveToCurrentMonth() {
        vm.timeline.setWindow(moment().subtract(1, 'month').startOf('day'), moment().endOf('day'));
        $('#btn-timeline-month').blur();
    }

    function moveToLastReport() {
        if (reportsSvc.lastReport) {
            moveToReport(reportsSvc.lastReport);
        }
        $('#btn-timeline-last').blur();
    }

    function moveToReport(report) {
        if (report) {
            vm.timeline.moveTo(moment(report.messageTimeStamp ?? report.timeOfReport).local().toDate().valueOf());
        }
    }
}
